<template>
    <Slide right>
        <router-link class="header-nav-link" to="/"><span>Home</span></router-link>
        <router-link class="header-nav-link" to="/environmental-impact/"><span>Environmental Impact</span></router-link>
        <router-link class="header-nav-link" to="/about-us/"><span>About Us</span></router-link>
        <router-link class="header-nav-link" to="/services/"><span>Services</span></router-link>
        <router-link class="header-nav-link" to="/testimonials/"><span>Testimonials</span></router-link>
        <router-link class="header-nav-link" to="/contact-us/"><span>Contact Us</span></router-link>
        <a href="tel:+441953661644" class="header-nav-link"><span><img src="@/assets/images/phone-white.png" height="15" width="15" alt="mobile-phone-menu"><strong class="phone phone--mobile-menu"> 01953 661644</strong></span></a>
    </Slide>
</template>

<script>
import { Slide } from 'vue-burger-menu'

export default {
  name: 'mobile-menu',
  components: {
    Slide
  }
}
</script>



// WEBPACK FOOTER //
// src/components/partials/MobileMenu.vue